import { bool, arrayOf, shape, number, string, oneOf, oneOfType, object } from 'prop-types'

// ===== COMPLEX SHAPES (Worth centralizing) =====

export const optionShape = shape({
  value: string,
  label: string,
})

export const useCaseEmbedShape = shape({
  id: string.isRequired,
  position: number.isRequired,
  externalId: string,
  source: oneOf(['youtube', 'vimeo', 'tiktok', 'x', 'instagram', 'facebook', 'upload', 'other', 'link']).isRequired,
  url: string,
  type: oneOf(['image', 'video', 'link']).isRequired,
})

export const printerTypeShape = shape({
  id: number,
  name: string,
  createdAt: string,
  updatedAt: string,
  hidden: bool,
  manufacturerId: number,
})

export const useCaseShape = shape({
  id: string.isRequired,
  technology: oneOf(['fdm', 'sla', 'sls', 'poly_jet', 'metal_printing', 'metal_jet', 'other', null]),
  printerType: printerTypeShape,
  status: oneOf(['submitted', 'accepted', 'rejected']).isRequired,
  itemId: number.isRequired,
  username: string.isRequired,
  likeCount: number.isRequired,
  liked: bool.isRequired,
  isLoading: bool,
  createdAt: string.isRequired,
  updatedAt: string.isRequired,
  useCaseEmbeds: arrayOf(useCaseEmbedShape).isRequired,
})

export const mediaShape = shape({
  id: string.isRequired,
  type: oneOf(['image', 'video']).isRequired,
  url: string,
  file: oneOfType([string, object]),
  preview: string,
})

export const notificationShape = shape({
  show: bool.isRequired,
  message: string,
  type: string,
})

export const printerTypeOptionShape = shape({
  label: string.isRequired,
  value: oneOfType([number, string]).isRequired,
  printerTypeId: oneOfType([number, string]),
  printerTypeName: string,
  technology: string,
})
